<template>
  <div class="communication-cost-container">
    <div class="header">
      <h2>通信费用设置</h2>
      <el-button type="primary" @click="handleAdd">新增费用</el-button>
    </div>

    <el-table :data="costList" border style="width: 100%">
      <el-table-column prop="name" label="费用名称" width="180"></el-table-column>
      <el-table-column prop="price" label="价格(元)" width="120"></el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row.dinsurance_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="费用名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入费用名称"></el-input>
        </el-form-item>
        <el-form-item label="价格(元)" prop="price">
          <el-input v-model="form.price" placeholder="请输入价格" type="number"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
              dialogVisible: false, // 控制对话框显示
      dialogTitle: '新增费用', // 对话框标题
        costList :[],
        /*form表单数据*/
        form: {
         name: '',
         price: '',
        },

        loading: false,
      };
    },
    created() {
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        SettingApi.getdinsurance({}, true)
          .then(data => {
            
            self.costList  =  data.data
          })
          .catch(error => {});

      },

          handleAdd() {
      this.dialogTitle = '新增费用'
      this.isEdit = false
      this.form = {
        id: '',
        name: '',
        price: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    //新增费用
        handleEdit(index, row) {
      this.dialogTitle = '编辑费用'
      this.isEdit = true
      this.currentIndex = index
      this.form = {
        id: row.id,
        name: row.name,
        price: row.price
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
        // 删除费用
handleDelete(dinsurance_id) {
  console.log('dinsurance_id',dinsurance_id)
  this.$confirm('确认删除该费用设置吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {

    let params = {
      dinsurance_id: dinsurance_id
    };
    
    // 应该调用删除API，而不是新增API
    SettingApi.deletedinsurance(params, true)
      .then(response => {
        if (response.code === 200) { // 假设成功返回code=200
          this.$message.success(response.message || '删除成功');
          this.getData(); // 刷新列表
        } else {
          this.$message.error(response.message || '删除失败');
        }
      })
      .catch(error => {
        console.error('删除失败:', error);
      });
  }).catch(() => {
    this.$message.info('已取消删除');
  });
},

    submitForm(){
 let self = this;
        self.loading = true;
      let params = {
        name: self.form.name,
        price: self.form.price
      };
        SettingApi.adddinsurance(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，短信通知新增成功',
              type: 'success'
            });
self.dialogVisible = false
          })
          .catch(error => {
            self.loading = false;
          });

    },
      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.editSms(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，短信通知设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },
      //发送短信
      sendOut() {
        let self = this;
        let params = this.form;
        SettingApi.sendSms(params, true)
          .then(data => {
            self.$message({
              message: '恭喜你，短信发送成功',
              type: 'success'
            });
            self.$router.push('/setting/Sms');

          })
          .catch(error => {

          });
      }



    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/dinsurance/index.vue